import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  openModals: {},
};

const modalSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.openModals[action.payload] = true;
    },
    closeModal: (state, action) => {
      state.openModals[action.payload] = false;
    },
  },
});

const { actions, reducer } = modalSlice;
export const { openModal, closeModal } = actions;

export default reducer;
